import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { isEmpty } from '@ember/utils';

export default class InAppMessagesIndexController extends Controller {
  @service router!: RouterService;

  get messageId() {
    let { currentRoute } = this.router;

    if (currentRoute.name === 'in-app-messages.message') {
      return currentRoute.params.message_id ?? '';
    }

    return '';
  }

  @action
  onMessageIdChange(messageId: string) {
    if (!isEmpty(messageId)) {
      this.router.transitionTo('in-app-messages.message', messageId);
    } else {
      this.router.transitionTo('in-app-messages');
    }
  }
}
